import { Component, OnInit } from '@angular/core';
import { DashboardService } from 'src/app/_services/dashboard/dashboard.service';

@Component({
  selector: 'app-big-card',
  templateUrl: './big-card.component.html',
  styleUrls: ['./big-card.component.scss']
})
export class BigCardComponent implements OnInit {

  chartOption = {
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow'
      }
    },
    legend: {
      data: ['2018', '2019', '2020', '2021']
    },
    
    toolbox: {
      show: true,
      orient: 'vertical',
      left: 'right',
      top: 'center',
      feature: {
        mark: { show: false },
        dataView: { show: false, readOnly: false },
        magicType: { show: true, type: ['line', 'bar', 'stack'] },
        restore: { show: true },
        saveAsImage: { show: true }
      }
    },
    xAxis: [
      {
        type: 'category',
        axisTick: { show: false },
        data: ['Settembre', 'Ottobre', 'Novembre']
      }
    ],
    yAxis: [
      {
        type: 'value'
      }
    ],
    series: [
      {
        name: '2018',
        type: 'bar',
        barGap: 0,
        emphasis: {
          focus: 'series'
        },
        data: [5412, 11458, 35126]
      },
      {
        name: '2019',
        type: 'bar',
        barGap: 0,
        emphasis: {
          focus: 'series'
        },
        data: [1254, 14400, 22500]
      },
      {
        name: '2020',
        type: 'bar',
        barGap: 0,
        emphasis: {
          focus: 'series'
        },
        data: [15145, 13300, 21045]
      },
      {
        name: '2021',
        type: 'bar',
        emphasis: {
          focus: 'series'
        },
        data: [8192, 34004, 23405]
      },
    ]
  };


  constructor(
    public dashboardService: DashboardService
  ) { }

  ngOnInit() {
  }

}
